import W from "./ghl-ui.es1159.js";
import v from "./ghl-ui.es1157.js";
import { composite as r, changeColor as e } from "./ghl-ui.es904.js";
const H = (p) => {
  const {
    lineHeight: x,
    borderRadius: f,
    fontWeightStrong: h,
    baseColor: o,
    dividerColor: u,
    actionColor: m,
    textColor1: c,
    textColor2: l,
    closeColorHover: s,
    closeColorPressed: n,
    closeIconColor: t,
    closeIconColorHover: C,
    closeIconColorPressed: i,
    infoColor: a,
    successColor: d,
    warningColor: I,
    errorColor: g,
    fontSize: S
  } = p;
  return Object.assign(Object.assign({}, W), {
    fontSize: S,
    lineHeight: x,
    titleFontWeight: h,
    borderRadius: f,
    border: `1px solid ${u}`,
    color: m,
    titleTextColor: c,
    iconColor: l,
    contentTextColor: l,
    closeBorderRadius: f,
    closeColorHover: s,
    closeColorPressed: n,
    closeIconColor: t,
    closeIconColorHover: C,
    closeIconColorPressed: i,
    borderInfo: `1px solid ${r(o, e(a, {
      alpha: 0.25
    }))}`,
    colorInfo: r(o, e(a, {
      alpha: 0.08
    })),
    titleTextColorInfo: c,
    iconColorInfo: a,
    contentTextColorInfo: l,
    closeColorHoverInfo: s,
    closeColorPressedInfo: n,
    closeIconColorInfo: t,
    closeIconColorHoverInfo: C,
    closeIconColorPressedInfo: i,
    borderSuccess: `1px solid ${r(o, e(d, {
      alpha: 0.25
    }))}`,
    colorSuccess: r(o, e(d, {
      alpha: 0.08
    })),
    titleTextColorSuccess: c,
    iconColorSuccess: d,
    contentTextColorSuccess: l,
    closeColorHoverSuccess: s,
    closeColorPressedSuccess: n,
    closeIconColorSuccess: t,
    closeIconColorHoverSuccess: C,
    closeIconColorPressedSuccess: i,
    borderWarning: `1px solid ${r(o, e(I, {
      alpha: 0.33
    }))}`,
    colorWarning: r(o, e(I, {
      alpha: 0.08
    })),
    titleTextColorWarning: c,
    iconColorWarning: I,
    contentTextColorWarning: l,
    closeColorHoverWarning: s,
    closeColorPressedWarning: n,
    closeIconColorWarning: t,
    closeIconColorHoverWarning: C,
    closeIconColorPressedWarning: i,
    borderError: `1px solid ${r(o, e(g, {
      alpha: 0.25
    }))}`,
    colorError: r(o, e(g, {
      alpha: 0.08
    })),
    titleTextColorError: c,
    iconColorError: g,
    contentTextColorError: l,
    closeColorHoverError: s,
    closeColorPressedError: n,
    closeIconColorError: t,
    closeIconColorHoverError: C,
    closeIconColorPressedError: i
  });
}, E = {
  name: "Alert",
  common: v,
  self: H
}, $ = E;
export {
  $ as default
};
